import { setDefaultOptions } from 'date-fns';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { DateFnsLocaleMapper } from 'shared/constants/dates';

import { getFnsLocale } from './utils';

import type { FnsLocale } from 'shared/types/fnsLocale';

export const useLocalization = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const setLocale = async () => {
      const fnsLocale = DateFnsLocaleMapper[i18n.language as FnsLocale];
      const locale = await getFnsLocale(fnsLocale);

      setDefaultOptions({ locale });
    };

    setLocale();
  }, [i18n.language]);
};
